import { render } from "./VehicleCharacteristicTabComponent.vue?vue&type=template&id=088e4d35&scoped=true"
import script from "./VehicleCharacteristicTabComponent.vue?vue&type=script&lang=js"
export * from "./VehicleCharacteristicTabComponent.vue?vue&type=script&lang=js"

import "./VehicleCharacteristicTabComponent.vue?vue&type=style&index=0&id=088e4d35&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088e4d35"]])

export default __exports__